module.exports = __webpack_public_path__ + "assets/img/share-wx-icon.35c462b4.png";